/**
 * The API layer rejects disposable email addresses with HTTP 400.
 * The server helper (server/utils/disposableEmailError.ts) re-throws an H3
 * error whose body is `{ data: { code: 'disposable' } }`; once serialized and
 * received by `$fetch` on the client it surfaces as `error.data.data.code`.
 * The extra `error.data.code` branch tolerates a flatter shape defensively.
 * Use this guard in catch blocks to show the dedicated message
 * (`generic.disposableEmail`) under the email input.
 */
export const isDisposableEmailError = (error: any): boolean =>
  (error?.status === 400 || error?.statusCode === 400) &&
  (error?.data?.data?.code === 'disposable' ||
    error?.data?.code === 'disposable')

/**
 * Re-throw only the disposable-email error so the calling component can surface
 * it under the email input, while other errors keep their existing handling.
 * Centralizes the guard shared by the composables.
 */
export const rethrowIfDisposable = (error: unknown) => {
  if (isDisposableEmailError(error)) throw error
}
